module.exports = __webpack_public_path__ + "img/user-women.0e8a7549.svg";